export default [

  {
    path: '/active-collegepic/index',
    name: 'index',
    component: () => import('@/views/active-collegepic/index'),
    meta: {
      title: '快来上传你的大学宿舍实拍图'
    }
  },
  {
    path: '/active-collegepic/upload/:id',
    name: 'upload',
    component: () => import('@/views/active-collegepic/upload'),
    meta: {
      title: '上传图片'
    }
  },
  {
    path: '/active-collegepic/myupload',
    name: 'myupload',
    component: () => import('@/views/active-collegepic/myupload'),
    meta: {
      title: '我的上传'
    }
  }
]
